export default __webpack_public_path__ + "static/media/scan_DE.55d8c59f.png";